module.exports = __webpack_public_path__ + "media/journey_sweepstakes/scholarship-journey-landing-divider-d97b8746.png";